import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, StatCard, Loader, Empty } from "@/components/kit";
import {
  Users, Building2, Briefcase, Trophy, Wallet, ShieldCheck, GraduationCap,
  Store, Activity, ArrowRight, ScrollText,
} from "lucide-react";

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setData(r.data)).catch(() => setData(false)); }, []);

  if (data === null) return <Loader label="Loading command centre" />;
  if (!data) return <Empty label="Could not load overview" />;

  const cards = [
    { label: "Total users", value: data.users, icon: Users, accent: "cobalt" },
    { label: "Professionals", value: data.professionals, icon: Users, accent: "emerald" },
    { label: "Organisations", value: data.organisations, icon: Building2, accent: "amber" },
    { label: "Pending verifications", value: data.pending_verifications, icon: ShieldCheck, accent: "crimson" },
    { label: "Opportunities", value: data.opportunities, icon: Briefcase, accent: "cobalt" },
    { label: "Tournaments", value: data.tournaments, icon: Trophy, accent: "amber" },
    { label: "Assignments", value: data.assignments, icon: Activity, accent: "emerald" },
    { label: "Bookings", value: data.bookings, icon: Store, accent: "crimson" },
    { label: "Payments", value: data.payments, icon: Wallet, accent: "emerald" },
    { label: "Courses", value: data.courses, icon: GraduationCap, accent: "cobalt" },
    { label: "Sports", value: data.sports, icon: Activity, accent: "amber" },
  ];

  const links = [
    { to: "/app/verifications", label: "Verification queue", icon: ShieldCheck, desc: "Review & approve workforce credentials" },
    { to: "/app/directory", label: "Workforce directory", icon: Users, desc: "Search the full professional pool" },
    { to: "/app/intelligence", label: "Krida Intelligence", icon: Activity, desc: "Government & workforce analytics" },
    { to: "/app/audit", label: "Audit logs", icon: ScrollText, desc: "Every governance action, traceable" },
  ];

  return (
    <div className="fade-up">
      <PageHeader overline="Krida Super Admin" title="Platform Command Centre"
        subtitle="Governance, verification, configuration and compliance across the workforce OS." testid="admin-dashboard" />

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
        {cards.map((c) => <StatCard key={c.label} {...c} testid={`admin-stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`} />)}
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        {links.map((l) => (
          <Link key={l.to} to={l.to} data-testid={`admin-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            className="krida-card p-6 flex items-center gap-4 hover:-translate-y-0.5 transition-all">
            <div className="w-12 h-12 rounded-xl bg-krida-crimson/10 grid place-items-center"><l.icon className="w-6 h-6 text-krida-crimson" /></div>
            <div className="flex-1"><div className="font-heading text-lg font-bold">{l.label}</div><div className="text-sm text-slate-500">{l.desc}</div></div>
            <ArrowRight className="w-5 h-5 text-slate-600" />
          </Link>
        ))}
      </div>
    </div>
  );
}
